import { render, staticRenderFns } from "./transfering-legal-recommendation.vue?vue&type=template&id=41297a0d"
import script from "./transfering-legal-recommendation.vue?vue&type=script&lang=js"
export * from "./transfering-legal-recommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports